'use strict';

const pages = {
    HOME: 'profile',
    PROJECTS: 'projects',
    COLLECTIONS: 'favorites',
};

const pageUrlLabels = {
    [pages.HOME]: '',
    [pages.PROJECTS]: 'projects',
    [pages.COLLECTIONS]: 'favorites',
};

const profileHeadStates = {
    FULL: 'full',
    TRANSITIONING: 'transitioning',
    STICKY: 'sticky',
    NARROW: 'narrow',
};

const els = {
    // View Elements
    PROFILE_WRAPPER: '#profile',
    PROFILE_HEAD: '#profileHead',
    PROFILE_PAGE: '#profilePage',
    PROFILE_TABS: '#profileTabs',
    PROFILE_BREADCRUMBS: '#profileBreadcrumbs',
    PROFILE_HOME: '#profileHome',
    DESIGNER_FAVORITES: '#profile-designerFavoritesBlock',
    INSTAGRAM_FEED: '#instagramFeed',
    PROFILE_PROJECTS: '#profileProjects',
    PROFILE_COLLECTIONS: '#profileCollections',
    COLLECTION_RESULTS: '#collectionResults',

    // PROFILE_WRAPPER Elements
    LOADING_SPINNER: '.profile-loadingSpinner',

    // PROFILE_HEAD Elements
    PROFILE_SHARE: '.profileHead-shareContainer',
    PROFILE_EMAIL: '.profileHead-emailContainer',
    PROFILE_PIC: '.profileHead-pictureWrapper',
    PROFILE_FOLLOW: '.profileHead-follow',

    // PROFILE_TABS Elements
    TAB: '.profileHead-tab',
    TAB_INDICATOR: '.profileHead-tabIndicator',

    // PROFILE_HOME Elements
    PROFILE_BUTTON: '.profile-button',
    READ_MORE: '.designerDetail-readMore',
    READ_LESS: '.designerDetail-readLess',
    OVERFLOW: '.designerDetail-overflow',
    OVERFLOW_TEXT: '.designerDetail-overflowText',
    DESIGNER_WEBLINK: '.designerDetail-webLink',
    CONTENT_LINK: '.contentLink',
};

const classes = {
    // PROFILE_HEAD state classes
    FULL: 'isFull',
    TRANS: 'isTransitioning',
    STICKY: 'isSticky',

    // PROFILE_HOME state classes
    HIDDEN: 'is-hidden',
    EXPANDED: 'expandDetails',

    PROFILE_PIC: 'profileHead-pictureWrapper',
    DESIGNER_FAVORITES_PRODUCTS: 'designerFavorites-products',
    PROJECT_TILE: 'projectTile',
};

// Events dispatched by profileHeadActions.es.js
const profileHeadEvents = {
    SETUP_STORE: 'head:setup-store',
    SET_STATE: 'head:set-state',
};

// Events dispatched by profilePageActions.es.js
const profilePageEvents = {
    SETUP_STORE: 'page:setup-store',
    SET_PAGE: 'page:set-page',
    SET_TEMPLATE: 'page:set-template',
    SET_ERROR: 'page:set-error',
};

// Events dispatched by collectionProductResultsActions.es.js
const collectionProductEvents = {
    SET_PORTFOLIO: 'product-results:set-portfolio',
    PRODUCTS_FETCHED: 'product-results:fetched',
};

module.exports = {
    ITEMS_IN_PREVIEW: 6,
    ITEMS_PER_PAGE: 60,

    profileHeadStates,
    pages,
    pageUrlLabels,
    els,
    classes,
    profileHeadEvents,
    profilePageEvents,
    collectionProductEvents,
};



// WEBPACK FOOTER //
// ./assets/js/profile/TradeProfileConstants.es.js